module.exports = __webpack_public_path__ + "static/media/MM.f627e6c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/MM.svg
// module id = 314
// module chunks = 0